module.exports = __webpack_public_path__ + "static/media/ic_print.6e8e5ca5.svg";